import {takeEvery} from 'redux-saga/effects'
import {
  ADD_EXAM_TYPE,
  DELETE_MANY_EXAM_TYPES,
  DELETE_SINGLE_EXAM_TYPE,
  GET_EXAM_TYPES,
  UPDATE_EXAM_TYPE,
  VIEW_SELECTED_EXAM_TYPE,
} from 'setup/redux/Actions/ExamType/ActionTypes/ApiActionTypes'

import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_EXAM_TYPES, fetchData)
  yield takeEvery(ADD_EXAM_TYPE, fetchData)
  yield takeEvery(DELETE_SINGLE_EXAM_TYPE, fetchData)
  yield takeEvery(DELETE_MANY_EXAM_TYPES, fetchData)
  yield takeEvery(UPDATE_EXAM_TYPE, fetchData)
  yield takeEvery(VIEW_SELECTED_EXAM_TYPE, fetchData)
}

export default dataSaga
